export const speeds = [1000, 800, 650, 500, 370, 200]
export const shape = [[0, 1, 0],[1, 1, 1],[0, 1, 0],[1, 0, 1]]
export const randomCarIndex = [-8, -9, -10, -11]
export const defaultSider = [1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0]

class Racing {
  constructor({ y, cars, sider, death, rng = Math.random }) {
    Object.defineProperty(this, 'rng', { value: rng })
    this.x = 15 //固定行
    this.y = y || 2
    this.cars = cars || [[-10, 2]]
    this.sider = sider || defaultSider
    this.death = death || false
  }

  addCar() {
    if (this.cars.length > 0 && this.cars[this.cars.length-1][0] <= 0) {
      return
    }
    this.cars = this.cars.concat([this.randomCar()])
  }

  removeCar() {
    this.cars = this.cars.filter(car => car[0]<20)
  }

  moveSider() {
    const item = this.sider[0]
    const newSider = this.sider.slice(1).concat(item)
    this.sider = newSider
  }

  run() {
    this.addCar()
    this.cars = this.cars.map(car => {
      return [car[0]+1, car[1]]
    })
    if (this.collisionDetection()) {
      this.death = true
    }
    this.removeCar()
    this.moveSider()
  }

  randomCar() {
    const idx = Math.floor((this.rng()*randomCarIndex.length))
    const x = randomCarIndex[idx]
    const y = this.rng() > 0.5 ? 2 : 5
    return [x, y]
  }

  collisionDetection(y = this.y) {
    return this.cars.some(car => car[1] === y && (car[0]>=13 && car[0]<18))
  }

  checkMove(nextY = this.y) {
    return !this.collisionDetection(nextY)
  }

  move(type) {
    const nextY = type === 'left' ? 2 : type === 'right' ? 5 : null
    if (nextY === null || !this.checkMove(nextY)) {
      return false
    }
    this.y = nextY
    return true
  }

  toJsObj() {
    const { ...object } = this
    return object
  }
}

export const createNewRacing = (rng = Math.random) => {
  return new Racing({ rng })
}

export default Racing
